import { render, staticRenderFns } from "./FormBuilderGeneralTab.vue?vue&type=template&id=3ed24e2b&"
import script from "./FormBuilderGeneralTab.vue?vue&type=script&lang=ts&"
export * from "./FormBuilderGeneralTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports